import { useStore } from '../../store';
import { STEPS } from './consts';
import { VIEWS_MAP } from '../../router/constants';

export const getInitialStep = (): string => {
  const { summary } = useStore.getState();
  if (summary?.emergencyBucketResponse?.accountId) {
    return STEPS.DASHBOARD;
  }
  return STEPS.INTRO;
};

export const getNextStepFromActiveStep = (activeStep: string) => {
  const next = { nextStep: '', reqNav: false };
  switch (activeStep) {
    case STEPS.SETUP:
    case STEPS.MONEY_MOVEMENT:
    case STEPS.TRANSACTIONS:
      next.nextStep = STEPS.DASHBOARD;
      break;

    case STEPS.DASHBOARD:
      next.nextStep = `/${VIEWS_MAP.DASHBOARD}`;
      next.reqNav = true;
      break;

    default:
      next.nextStep = STEPS.DASHBOARD;
  }
  return next;
};

export const getNavHeaderFromActiveStep = (activeStep: string, movementType: boolean, isSavingsBucket:boolean, translate: any) => {
  const entityType = isSavingsBucket ? translate('EMERGENCY_BUCKET_HEADER_PRO') : translate('EMERGENCY_BUCKET_HEADER_BASIC');
  const MAP = {
    [STEPS.DASHBOARD]: entityType,
    [STEPS.SETUP]: entityType,
    [STEPS.MONEY_MOVEMENT]: movementType ? `${translate('SAVINGS_BUCKET.MOVE_MONEY_WITHDRAW')} ${entityType}` : `${translate('SAVINGS_BUCKET.MOVE_MONEY_ADD')} ${entityType}`,
    [STEPS.TRANSACTIONS]: `${entityType} ${translate('SAVINGS_BUCKET.TRANSACTIONS')}`,
  };
  return MAP[activeStep as keyof typeof MAP];
};

export const NUMBER_TO_DAY_MAP = {
  1: 'Sunday',
  2: 'Monday',
  3: 'Tuesday',
  4: 'Wednesday',
  5: 'Thursday',
  6: 'Friday',
  7: 'Saturday',
};
